import React from 'react';
import { Flow } from 'flow-react';
import { observer } from 'mobx-react';
import { connect } from 'react-redux';
import { withRouter } from 'helpers/ModuleHelper';
import { injectIntl } from 'react-intl';
import * as actions from 'store/actions';
import Card from 'react-bootstrap/Card';
import * as ConfigTypes from 'config/ConfigTypes';
import { getMetaConfig } from "helpers/ConfigHelper";
import { parseStringField, checkGroupFields, checkMapping, showMappingLangType } from "helpers/FieldHelper";
import { showCalendar, showWishList } from "helpers/CartHelper";
import { sliceText } from "helpers/FieldHelper";
import { getImgUrl } from "helpers/ImageHelper";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlay } from '@fortawesome/free-solid-svg-icons';
import { canShow } from "helpers/CalendarHelper";
import './Item.scss';

const Item = observer(
    class Item extends React.Component {
        constructor(props) {
            super(props);
            this.state = {}
        }

        fm = ({ id }) => this.props.intl.formatMessage({ id });

        onItem = () => {
            const { wpView } = this.props.mediaObjects;
            this.props.updateMediaObjects({
                currentClip: this.props.item,
                wpView: ConfigTypes.ITEM_DETAIL,
                viewMode: ConfigTypes.ITEM_DETAIL,
                toTop: true,
                lastView: wpView
            });
            this.props.router.navigate(`${ConfigTypes.ITEM_PATH}/${this.props.item.id}`);
        }

        showPortraitCard = (wpView) => {
            const imgUrl = getImgUrl({ stateCurrentClip: this.props.item });
            const showFields = getMetaConfig({ wpView, props: this.props, configName: ConfigTypes.ITEM });
            return (
                <Card className="item-card">
                    <Card.Img variant="top" src={imgUrl} onClick={this.onItem}
                        className="item-card-img" />
                    <Card.Body>
                        {showFields.map((el, i) => (
                            <div key={`itemItemGridItem${i}`}
                                className={el[`${wpView}html`] ? 'item-card-title' : 'item-card-text'}>
                                {parseStringField(this.props.item.metadata.fields[el.field])}
                                {checkGroupFields({ isGroup: el[`${wpView}group`], el, element: this.props.item, wpView })}
                            </div>))}
                    </Card.Body>
                </Card>)
        }

        showGridItem = (wpView) => {
            const imgUrl = getImgUrl({ stateCurrentClip: this.props.item });
            const showFields = getMetaConfig({ wpView, props: this.props, configName: ConfigTypes.OBJECT });
            return this.showPortraitCard(wpView);
        }

        showItem = () => {
            const { wpView } = this.props.mediaObjects;
            if (wpView == ConfigTypes.WORK_GRID) {
                return this.showGridItem(wpView);
            } else if (wpView == ConfigTypes.WORK_LIST) {
                const showFields = getMetaConfig({ viewMode: wpView, props: this.props, configName: ConfigTypes.OBJECT });
                const imgUrl = getImgUrl({ stateCurrentClip: this.props.item });
                return (
                    <li className="list-group-item item-list-item" onClick={this.onItem}>
                        <img className="img-responsive img-rounded item-img" src={imgUrl} alt="" />
                        {showFields.map((el, i) => {
                            return (
                                <div key={`itemItemListItem${i}`}
                                    className={el[`${wpView}html`] ? 'item-card-title' : 'item-card-text'}>
                                    {/* {this.props.item.metadata.fields[el.field] || ''} */}
                                    {parseStringField(this.props.item.metadata.fields[el.field])}
                                    {checkGroupFields({ isGroup: el[`${wpView}group`], el, element: this.props.item, wpView })}
                                </div>)
                        })}
                    </li>)
            }
        }

        getItemClasses = (el) => {
            const { wpView } = this.props.mediaObjects;
            let classes = "item-card-text";
            if (el[`${wpView}html`]) classes = 'item-card-title';
            if (wpView == ConfigTypes.WORK_LIST) {
                classes = 'item-card-title-list item-card-item-list';
            }
            return classes;
        }

        isPlayer = () => {
            let isPlayer = false;
            if (this.props.item && this.props.item.mediafiles
                && this.props.item.mediafiles.elements && this.props.item.mediafiles.elements.length) {
                isPlayer = true;
            }
            return isPlayer;
        }

        showLangInfo = ({ el, wpView, i }) => {
            let fValue = "";
            if (this.props.item.metadata && this.props.item.metadata.fields
                && this.props.item.metadata.fields[el.field]) {
                fValue = this.props.item.metadata.fields[el.field];
            }
            return (<div key={`itemItemListItem${i}`} onClick={this.onItem}
                className={this.getItemClasses(el)}>
                {showMappingLangType({ el, viewMode: wpView, fValue, txtClass: '', onlyType: true })}
            </div>
            )
        }

        showItems = () => {
            const { wpView } = this.props.mediaObjects;
            const { isLoggedIn } = this.props.authObjects;
            let htmlClasses = "item-card-conten-grid";
            if (wpView == ConfigTypes.WORK_GRID) {
                return this.showGridItem(wpView);
            } else if (wpView == ConfigTypes.WORK_LIST) {
                const showFields = getMetaConfig({ viewMode: wpView, props: this.props, configName: ConfigTypes.ITEM });
                const imgUrl = getImgUrl({ stateCurrentClip: this.props.item });
                htmlClasses = "item-card-content-list";
                return (
                    <li className="list-group-item item-list-item" >
                        <div className="item-card-content-list">
                            {showFields.map((el, i) => {
                                let fieldTxt = parseStringField(this.props.item.metadata.fields[el.field]);
                                fieldTxt = checkMapping({ el, fieldTxt });
                                if (i == 0) {
                                    return (
                                        <div className="item-card-imgbox" key={`itemItemListItem${i}`} onClick={this.onItem}>
                                            {/* <img className="img-responsive img-rounded item-img" src={imgUrl} alt="" /> */}
                                            {this.isPlayer() && <FontAwesomeIcon icon={faCirclePlay} />}
                                        </div>
                                    )
                                }
                                if (i == 9 && ConfigTypes.SHOW_CART && isLoggedIn) {
                                    return showWishList({ item: this.props.item, props: this.props, fm: this.fm });
                                }
                                if (el[`${wpView}type`] === ConfigTypes.CALENDAR && isLoggedIn) {
                                    return showCalendar({ item: this.props.item, fm: this.fm, props: this.props, isCartSymbol: true });
                                }

                                if (el[`${wpView}languagetype`]) {
                                    return this.showLangInfo({ el, wpView, i });
                                }
                                return (<div key={`itemItemListItem${i}`} onClick={this.onItem}
                                    className={this.getItemClasses(el)}>
                                    {sliceText(fieldTxt, 40)}
                                    {checkGroupFields({ isGroup: el[`${wpView}group`], el, element: this.props.item, viewMode: wpView })}
                                </div>)
                            }
                            )}
                        </div>
                    </li>)
            }
        }

        componentDidMount() { 
            const { currentClip } = this.props.mediaObjects;
            const { isLoggedIn } = this.props.authObjects;
            if ((ConfigTypes.SHOW_CART && isLoggedIn
                    && canShow({ item: currentClip, props: this.props }))) {
                this.props.getBlocks({id:this.props.item.id});
            }
        }

        render() {
            return this.showItems();
        }
    }
);

const mapStateToProps = (state) => ({
    mediaObjects: state.media.mediaObjects,
    configObjects: state.config.configObjects,
    cartObjects: state.cart.cartObjects,
    authObjects: state.auth.authObjects,
});

const mapDispatchToProps = (dispatch) => ({
    updateAuthObjects: (obj) => dispatch(actions.updateAuthObjects(obj)),
    updateMediaObjects: (obj) => dispatch(actions.updateMediaObjects(obj)),
    updateCartObjects: (obj) => dispatch(actions.updateCartObjects(obj)),
    addToFeCart: (obj) => dispatch(actions.addToFeCart(obj)),
    editFeRentel: (obj) => dispatch(actions.editFeRentel(obj)),
    addToWatchlist: (obj) => dispatch(actions.addToWatchlist(obj)),
    getBlocks: (obj) => dispatch(actions.getBlocks(obj))
});

export default Flow.injectFlow(connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(Item))));